import Cookies from 'js-cookie';

export const adminRequestConfig = () => ({
  headers: { Authorization: `Bearer ${Cookies.get('token') || localStorage.getItem('token') || ''}` },
});
